import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetUsersOnlineInterface } from 'domain/usecases';

interface IUsersState {
  usersOnline: GetUsersOnlineInterface.Result;
}

interface IPayloadUsersOnlineListData
  extends PayloadAction<GetUsersOnlineInterface.Result> {}

const initialState: IUsersState = {
  usersOnline: null,
};

export const UsersOnlineSlice = createSlice({
  name: 'users-slice',
  initialState,
  reducers: {
    loadUsersOnlineListData: (state, action: IPayloadUsersOnlineListData) => {
      state.usersOnline = action.payload;
    },
    clearUsersOnlineListData: (state) => {
      state.usersOnline = null;
    },
  },
});

export const { loadUsersOnlineListData, clearUsersOnlineListData } =
  UsersOnlineSlice.actions;

export default UsersOnlineSlice.reducer;
